// Financial amounts are stored to two decimal places in AUD.
// Distribute the original amount in integer cents to preserve the period total.
export function toCents(amount) {
  const value = Number(amount);
  if (!Number.isFinite(value)) throw new Error('Amount must be finite');
  if (Math.abs(value) > 90071992547409.90) throw new Error('Amount exceeds supported range');
  // Round halves away from zero, retaining cents as safe integers.
  const cents = Math.round((Math.abs(value) + Number.EPSILON * Math.abs(value)) * 100);
  return Math.sign(value) * cents;
}

export function fromCents(cents) {
  return cents / 100;
}

export function allocateDailyAmounts(amount, days) {
  if (!Number.isInteger(days) || days < 1) throw new Error('Coverage days must be a positive integer');
  const total = toCents(amount);
  const sign = Math.sign(total);
  const absolute = Math.abs(total);
  const base = Math.floor(absolute / days);
  const remainder = absolute % days;
  return Array.from({ length: days }, (_, index) =>
    fromCents(sign * (base + (index < remainder ? 1 : 0)))
  );
}

export function sumMoney(items, getter = item => item.amount) {
  return fromCents(items.reduce((sum, item) => sum + toCents(getter(item)), 0));
}

// Date strings are calendar dates, not UTC timestamps.
export function calendarDate(value) {
  if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value)) {
    const [year, month, day] = value.split('-').map(Number);
    const d = new Date(Date.UTC(year, month - 1, day));
    return d.getUTCFullYear() === year && d.getUTCMonth() === month - 1 && d.getUTCDate() === day ? value : '';
  }
  const d = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(d.getTime())) return '';
  return [d.getFullYear(), String(d.getMonth() + 1).padStart(2, '0'), String(d.getDate()).padStart(2, '0')].join('-');
}

export function countCoverageDays(start, end) {
  const a = calendarDate(start);
  const b = calendarDate(end);
  if (!a || !b) throw new Error('Invalid coverage dates');
  const parse = s => Date.UTC(Number(s.slice(0,4)), Number(s.slice(5,7)) - 1, Number(s.slice(8,10)));
  const result = Math.round((parse(b) - parse(a)) / 86400000) + 1;
  if (result < 1) throw new Error('Coverage end precedes start');
  return result;
}

export function isActiveEntry(transaction) {
  return !transaction.isDeleted && Number.isFinite(Number(transaction.amount));
}

export function isPostedByDate(transaction, asOf = new Date()) {
  return isActiveEntry(transaction) &&
    transaction.status === 'posted' &&
    calendarDate(transaction.date) <= calendarDate(asOf);
}